import { AiSummaryState } from './types';

const INITIAL_STATE: AiSummaryState = {
  open: false,
  loading: false,
  stepIndex: 0,
  resumo: null,
};

// eslint-disable-next-line default-param-last
export default function aiSummary(state = INITIAL_STATE, action: any): AiSummaryState {
  switch (action.type) {
    case '@ai/OPEN_SUMMARY':
      return { ...state, open: true };

    case '@ai/CLOSE_SUMMARY':
      return INITIAL_STATE;

    case '@ai/START_LOADING':
      return { ...state, loading: true, resumo: null, stepIndex: 0 };

    case '@ai/SET_STEP':
      return { ...state, stepIndex: action.payload };

    case '@ai/SET_RESUMO':
      return {
        ...state,
        loading: false,
        resumo: action.payload,
      };

    default:
      return state;
  }
}
